import alt from 'alt'
import axios from 'axios'
import { API_BASE } from 'consts'

const AssetUploaderSource = {
  upload: function(file, filename) {
    const formData = new FormData()
    formData.append("file", file, filename)

    return axios.post(`${API_BASE}/shopify_assets`, formData, { catchErrors: false })
  },

  delete: function(filename) {
    return axios.delete(
      `${API_BASE}/shopify_assets/${filename}`, { catchErrors: false }
    )
  }
}

export default AssetUploaderSource



// WEBPACK FOOTER //
// ./app/sources/AssetUploaderSource.js